import script from "./Wins.vue?vue&type=script&setup=true&lang=js"
export * from "./Wins.vue?vue&type=script&setup=true&lang=js"

import "./Wins.vue?vue&type=style&index=0&id=f6b0b926&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b0b926"]])

export default __exports__